import React, { createContext, useState, useEffect, useContext } from 'react';
import { fetchCurrentUser } from '../api/user-service.js'; 
import { reportError } from '../utils/datadog.js';

export const CurrentUserContext = createContext();

export function CurrentUserProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCurrentUser()
      .then((response) => {
        setUser(response?.data);
      })
      .catch(() => {
        // No user in session. Keep user object null until one is created after step 1. 
        setUser(null);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const login = () => {
    window.location.href = '/login';
  };

  const logout = () => {
    window.location.href = '/logout';
  };

  const logoutAndRedirect = ({redirectUrl}) => {
    window.location.href = '/logout?redirect=' + redirectUrl;
  };

  const refreshCurrentUser = async () => {
    try {
      const response = await fetchCurrentUser();
      setUser(response?.data);
      return response?.data;
    } catch (error) {
      reportError('RefreshCurrentUserError: ' + error?.message, { error, userId: user?.id });
      return null;
    }
  };

  return (
    <CurrentUserContext.Provider value={{ user, loading, login, logout, logoutAndRedirect, refreshCurrentUser }}>
      {children}
    </CurrentUserContext.Provider>
  );
}

export function useCurrentUser() {
  const ctx = useContext(CurrentUserContext);
  if (!ctx) throw new Error('useCurrentUser must be inside CurrentUserProvider');
  return ctx;
}
